import React, { FC } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

import { IOffice } from '../../../models/types';

import Icon from '../../Icon';
import IconWrapper from '../../Icon/IconWrapper';
import Typography from '../../Typography';

import DrawerContentItem from '../DrawerContentItem';
import { paths } from '../../../routes/Root/paths';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

interface IProps {
  isLoading: boolean;
  office: IOffice | null;
}

const DrawerContentOffice: FC<IProps> = ({ isLoading, office }) => {
  const defaultOffice = { name: '', address: '', id: 0 };
  const { name, address, id } = office || defaultOffice;
  const history = useHistory();
  const handleClick = () => () => {
    history.push(paths.map.office.edit(id));
  };
  const icon = (
    <IconWrapper variant="square" size="xl">
      <Icon name="business" size="m" />
    </IconWrapper>
  );

  const content = (
    <>
      <Typography variant="p1Medium">{isLoading ? <Skeleton /> : name}</Typography>
      <Typography variant="p2Regular" color="text-secondary">
        {isLoading ? <Skeleton /> : address}
      </Typography>
    </>
  );
  const action = (
    <Button type={'text'} size={'large'} icon={<EditOutlined />} onClick={handleClick()} />
  );

  return <DrawerContentItem variant="current" icon={icon} content={content} action={action} />;
};

export default DrawerContentOffice;
